<template lang="html">
  <article class="hero">
    <h2 class="hero__title--top"><span>{{titleTop}}</span></h2>
    <h2 class="hero__title--bottom"><span>{{titleBottom}}</span></h2>
    <h3 class="hero__subtitle"><span>{{subtitle}}</span></h3>
    <button class="hero__play hover" @click="openVideo"><span>play</span></button>
  </article>
</template>

<script>
import anime from 'animejs';
export default {
  name: 'Hero',
  props: ['titleTop','titleBottom','subtitle'],
  mounted() {
    anime({
      targets: ['.hero__title--top span','.hero__title--bottom span'],
      translateY: ["1.1em", 0],
      translateZ: 0,
      duration: 2000,
      easing: 'easeInOutCubic',
      delay: function(el, i) {
        return 500 * i + 1000;
      }
    });
    anime({
      targets: '.hero__subtitle span',
      translateY: ["-1.2em", 0],
      translateZ: 0,
      duration: 1000,
      easing: 'easeInOutCubic',
      delay: 2500
    });
    anime({
      targets: '.hero__play span',
      translateX: ["-180%", 0],
      translateZ: 0,
      duration: 1000,
      easing: 'easeInOutCubic',
      delay: 3000
    });

  },
  methods: {
    openVideo() {
      this.$store.commit('openVideo');
    }
  }
}
</script>

<style lang="scss">
@import "../styles/config.scss";
.hero {
  text-align: left;
  width: 100%;
  max-width: 1240px;
  padding: 0 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  transition: transform 1s cubic-bezier(0.23, 1, 0.32, 1), opacity .6s cubic-bezier(0.23, 1, 0.32, 1);
  span {
    display: inline-block;
  }
  &__title {
    font-family: CamptonBold;
    font-size: 90px;
    letter-spacing: 1px;
    line-height: 1.3;
    overflow: hidden;
    &--top {
      @extend .hero__title;
      color: transparent;
      -webkit-text-stroke-width: 1px;
      -webkit-text-stroke-color: var(--Neu01);
    }
    &--bottom {
      @extend .hero__title;
      color: var(--Neu01);
      top: -30px;
    }
  }
  &__subtitle {
    font-family: CamptonBold;
    font-size: 18px;
    letter-spacing: 1.5px;
    color: var(--Neu01);
    overflow: hidden;
    margin-bottom: 100px;
  }
  &__play {
    background-color: transparent;
    display: inline-block;
    border: none;
    //padding: 0;
    margin: 0;
    font-family: CamptonBold;
    font-size: 20px;
    color: var(--Neu01);
    overflow: hidden;
    &:before {
      content: url(../assets/play.svg);
      margin-right: 10px;
      top: 3px;
      position: relative;
      opacity: 0;
      animation: playBtn 1s linear 3.5s forwards;
    }
  }
  @include mq(0, 768px) {
    &__title {
      font-size: 60px;
      line-height: 1.2;
      &--bottom {
        top: 0;
      }
    }
    &__subtitle {
      margin-top: 20px;
      margin-bottom: 60px;
    }
  }
}
@keyframes playBtn {
  to {opacity:1;}
}

</style>



// WEBPACK FOOTER //
// src/components/Hero.vue